jQuery(document).ready(function ($) {
  function isElementInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function animateNumbers($element) {
    $element.find(".statistic-card--number").each(function () {
      var $this = $(this),
        countTo = parseInt($this.text(), 10); // Make sure it's a number

      $({ countNum: 0 }).animate(
        { countNum: countTo },
        {
          duration: 2000,
          easing: "linear",
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(this.countNum);
          },
        }
      );
    });
  }

  // Set an initial 'animated' data attribute to false for each statistic card
  $(".statistic-cards").each(function () {
    var $this = $(this);
    $this.data("animated", false);
  });

  function checkAndAnimateCards() {
    $(".statistic-cards").each(function () {
      var $this = $(this);
      if (isElementInViewport(this) && !$this.data("animated")) {
        animateNumbers($this);
        $this.data("animated", true); // Mark as animated
      }
    });
  }

  // Trigger on initial load
  checkAndAnimateCards();

  // Trigger on scroll
  $(window).scroll(function () {
    checkAndAnimateCards();
  });
});
